module.exports = __webpack_public_path__ + "static/media/Harsh_Vador.847e9fff.jpg";